export const UnitActivityChart = ({ inputData, totalUnitsCount }) => {
  return <main>
    <div className="card h-100">
      <div className="card-body pt-0">            
        <div className="row">
          <div
            style={{ fontSize: "3.5rem", fontWeight: "bold" }}
            className="py-4"
          >
            <strong>
              {inputData[0].amount}/{totalUnitsCount || 0}
            </strong>
          </div>
        </div>
        <h6 className="card-title text-muted mt-3 mb-0 customBoldSoft"><strong>ACTIVE UNITS</strong></h6>
      </div>
    </div>
  </main>;
}